<template lang="html">
  <div class="tracks-list">
    <div class="list">
      <ul>
        <li>
          <div class="item-content">
            <div class="item-inner">
              <div class="item-title">
                <AtlasCity :coords="[2.14095,48.9538]" flag />
                / <AtlasCity :coords="[2.14095,48.9548]" />
              </div>
              <div class="item-after">
                80km
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <pre>{{ tracks }}</pre>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'TracksList',
  computed: {
    ...mapGetters({
      collection: 'db/collection'
    })
  },
  data () {
    return {
      tracks: []
    }
  },
  methods: {
    getTracks () {
      this.collection('tracks').then(res => {
        this.tracks = res.rows
      })
    }
  },
  created () {
    this.getTracks()
  }
}
</script>

<style lang="scss">
.tracks-list {

}
</style>
